import { FC } from 'react';
import { Spin } from 'antd';

import { LoadingContainerStyled } from './LoadingFullscreen.styles';

export const LoadingFullscreen: FC = () => (
	<LoadingContainerStyled>
		<Spin size='large' />
	</LoadingContainerStyled>
);
